export default __webpack_public_path__ + "static/media/1631.64ad27c6.png";